type LoginServiceUrl = '/v2/login/default' | `/v2/login/project/${string}`;

const getBaseUrl = (projectId?: string) => {
  if (!projectId) return '/v2/login/default' as LoginServiceUrl;
  return `/v2/login/project/${projectId}` as LoginServiceUrl;
};

interface GetURLOptions {
  backTo?: string;
  projectId?: string;
}

export const getLoginURL = (options?: GetURLOptions) => {
  const {
    backTo = window.location.origin,
    // projectId, // NOTE Realm login disabled for now
  } = options || {};
  return `${getBaseUrl()}?backTo=${encodeURIComponent(backTo)}`;
};

export const getLogoutURL = (options?: GetURLOptions) => {
  const {
    backTo = window.location.origin,
    // projectId, // NOTE Realm login disabled for now
  } = options || {};
  return `${getBaseUrl()}?backTo=${encodeURIComponent(backTo)}&logout`;
};
